import { Colors } from '@oy/uicore';
import { Spacer, Text } from '@oy/uidesktop';
import { SystemIcon } from '@oy/uiicon';
import { useTranslate } from 'src/hooks';
import styles from '../Sidebar.module.css';

type ApiKeyStagingComponentProps = {
  apiKeyStaging: string | null | undefined;
  onClickCopyButton: () => void;
};

export const ApiKeyStagingComponent = ({
  apiKeyStaging,
  onClickCopyButton,
}: ApiKeyStagingComponentProps) => {
  const { getTranslation } = useTranslate();
  return (
    <section className={styles.apiKeyStaging}>
      <Text textStyle={Text.Style.BodySmSemibold} color={Colors.BLACK60}>
        {getTranslation('sidebar_apiKeyStagingComponent_title')}
      </Text>
      <Spacer top={Spacer.Size.XS} className={styles.apiKeyStagingBottom}>
        <Text textStyle={Text.Style.BodyMdRegular} color={Colors.BLACK100}>
          {`${apiKeyStaging?.substring(
            0,
            Math.min(apiKeyStaging.length, 20),
          )}...`}
        </Text>
        <section onClick={onClickCopyButton}>
          <SystemIcon
            name="copy"
            color={Colors.BLACK100}
            className={styles.copyBtn}
          />
        </section>
      </Spacer>
    </section>
  );
};
